import * as React from 'react';

export function MobileIconSvg() {
    return <svg
        aria-hidden="true"
        focusable="false"
        width="24"
        height="24"
        viewBox="0 0 24 24">
        <path fillRule="evenodd" clipRule="evenodd" d="M6 4a1 1 0 011-1h10a1 1 0 011 1v16a1 1 0 01-1 1H7a1 1 0 01-1-1V4zm5 15a1 1 0 112 0 1 1 0 01-2 0zm6-15H7v13h10V4z" fill="currentColor"></path><path opacity=".6" fill="currentColor" d="M8 5h8v11H8z"></path></svg>;
}

export function TabletIconSvg() {
    return <svg
        aria-hidden="true"
        focusable="false"
        width="24"
        height="24"
        viewBox="0 0 24 24">
        <path fillRule="evenodd" clipRule="evenodd" d="M4 4a1 1 0 011-1h14a1 1 0 011 1v16a1 1 0 01-1 1H5a1 1 0 01-1-1V4zm7 15a1 1 0 112 0 1 1 0 01-2 0zm8-15H5v13h14V4z" fill="currentColor"></path><path opacity=".6" fill="currentColor" d="M6 5h12v11H6z"></path></svg>;
}

export function DesktopIconSvg() {
    return <svg
        aria-hidden="true"
        focusable="false"
        width="24"
        height="24"
        viewBox="0 0 24 24">
        <path fillRule="evenodd" clipRule="evenodd" d="M3 2a1 1 0 00-1 1v13a1 1 0 001 1h18a1 1 0 001-1V3a1 1 0 00-1-1H3zm18 1H3v12h18V3z" fill="currentColor"></path><path fill="currentColor" d="M13 19h4v2h-4zm-6 0h4v2H7z"></path><path opacity=".6" fill="currentColor" d="M4 4h16v10H4z"></path></svg>;

}

export function AllDevicesIconSvg() {
    return <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24.5077 10H20.4989C20.2277 10 20.0078 10.2199 20.0078 10.4911V10.8928H24.9988V10.4911C24.9988 10.2199 24.7789 10 24.5077 10Z" fill="black" />
        <path fillRule="evenodd" clipRule="evenodd" d="M25 11.3928H20V19.3928H25V11.3928ZM22.9993 17.3928H21.9993V18.3928H22.9993V17.3928Z" fill="black" />
        <path d="M20.4989 20.7856L24.5077 20.7856C24.7789 20.7856 24.9988 20.5658 24.9988 20.2946L24.9988 19.8928L20.0078 19.8928L20.0078 20.2946C20.0078 20.5658 20.2277 20.7856 20.4989 20.7856Z" fill="black" />
        <path d="M10.325 13H19.2625V11H10.325V13Z" fill="black" />
        <path d="M20.5992 1.33922C20.5992 0.599579 19.9997 0 19.26 0H5.86779C5.12814 0 4.52856 0.599579 4.52856 1.33922V4.01767H8.3166C9.42898 4.01892 10.3305 4.92038 10.3317 6.03279V11.16H19.2599V10.7583C19.2624 10.0132 19.8544 9.40384 20.5991 9.3797L20.5992 1.33922Z" fill="black" />
        <path d="M10.3484 14H15.5273V15.7856H10.3484V14Z" fill="black" />
        <path fillRule="evenodd" clipRule="evenodd" d="M9.43779 19.6223H0.0632324V6.76477H9.43779V19.6223ZM5.74104 16.951H4.00001V18.5H5.74104V16.951Z" fill="black" />
        <path d="M8.25184 4.8777H1.12182C0.502131 4.87825 8.31203e-05 5.38032 -0.000488281 6V6.21693H9.37407V6C9.37351 5.38032 8.87152 4.87827 8.25184 4.8777Z" fill="black" />
        <path d="M1.12223 21.6223L8.25225 21.6223C8.87194 21.6217 9.37398 21.1197 9.37456 20.5L9.37456 20.2831L1.1708e-07 20.2831L9.81158e-08 20.5C0.000558053 21.1197 0.502548 21.6217 1.12223 21.6223Z" fill="black" />
        <path d="M17.7593 16.6784H10.3848V17.5713H18.2057V17.1248C18.2057 16.8783 18.0058 16.6784 17.7593 16.6784Z" fill="black" />
    </svg>;
}

type InfoIconSvgProps = {
    borderColor: string; 
    fontColor: string;
    backgroundColor: string; 
}
export function InfoIconSvg({ borderColor, fontColor, backgroundColor }: InfoIconSvgProps) {
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7.88194" cy="8.04503" r="6.80479" fill={backgroundColor} stroke={borderColor} />
        <path d="M6.83826 12.219C6.83826 12.7943 7.30653 13.2626 7.8818 13.2626C8.45707 13.2626 8.92534 12.7943 8.92534 12.219C8.92534 11.6438 8.45707 11.1755 7.8818 11.1755C7.30653 11.1755 6.83826 11.6438 6.83826 12.219Z" fill={fontColor} />
        <path d="M7.8818 10.1319C8.45707 10.1319 8.92534 9.66367 8.92534 9.0884V3.87069C8.92534 3.29542 8.45707 2.82715 7.8818 2.82715C7.30653 2.82715 6.83826 3.29542 6.83826 3.87069V9.0884C6.83826 9.66367 7.30653 10.1319 7.8818 10.1319Z" fill={fontColor} />
    </svg>;
}